import { render, staticRenderFns } from "./CanvasLogo.vue?vue&type=template&id=6e396a97&scoped=true&"
import script from "./CanvasLogo.vue?vue&type=script&lang=js&"
export * from "./CanvasLogo.vue?vue&type=script&lang=js&"
import style0 from "./CanvasLogo.vue?vue&type=style&index=0&id=6e396a97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e396a97",
  null
  
)

export default component.exports